<script setup lang="ts">
import { capitalize } from '@/Composables/capitalize.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps<{
    data?: {
        tooltip?: string
        icon: string | string[]
        class?: string
    },
    title?: string
}>()

const isImage = (icon: string) => {
    if (!icon) return false
    return !icon.includes(' ')
}

const iconPraCetak = `<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.7 83.7" width="1em" height="1em">
  <rect x="1.5" y="1.5" width="80.7" height="80.7" rx="6.15" ry="6.15" stroke="currentColor" style="fill:none; stroke-miterlimit:10; stroke-width:3px;"/>
  <g fill="currentColor">
    <path d="M18.92,35.43c-1.9-.99-3.39-2.38-4.47-4.16-1.08-1.78-1.62-3.81-1.62-6.07s.54-4.29,1.62-6.07c1.08-1.78,2.57-3.17,4.47-4.16s4.04-1.49,6.4-1.49c2.18,0,4.12,.38,5.83,1.15,1.71,.77,3.12,1.88,4.23,3.33l-4.77,4.26c-1.39-1.75-3.02-2.63-4.9-2.63-1.58,0-2.85,.51-3.81,1.52-.96,1.01-1.44,2.38-1.44,4.08s.48,3.07,1.44,4.08c.96,1.01,2.23,1.52,3.81,1.52,1.88,0,3.51-.88,4.9-2.63l4.77,4.26c-1.11,1.45-2.52,2.56-4.23,3.33-1.71,.77-3.65,1.15-5.83,1.15-2.37,0-4.5-.5-6.4-1.49Z"/>
    <path d="M63.98,36.4l-.06-10.22-4.87,8.2h-3.33l-4.87-7.85v9.86h-6.89V13.99h6.21l7.3,11.94,7.11-11.94h6.21l.06,22.42h-6.88Z"/>
    <path d="M30.63,62.09v8.13h-7.56v-8.23l-8.45-14.19h7.97l4.58,7.75,4.61-7.75h7.3l-8.45,14.28Z"/>
    <path d="M55.57,62.8l-1.7,1.89v5.54h-7.43v-22.42h7.43v8.13l7.37-8.13h8.23l-8.97,9.86,9.41,12.55h-8.74l-5.6-7.43Z"/>
  </g>
</svg>`;

const generateIcon = (icon: string) => {
    switch (icon) {
        case 'pracetak': 
            return iconPraCetak
        default: 
            return null
        
    }
}
</script>

<template>

    <span
        v-if="generateIcon(data?.icon)"
        v-html="generateIcon(data?.icon)"
        v-tooltip="title ? title : capitalize(data.tooltip || '')"
        :class="data?.class"
        aria-hidden="true"
    />

    <FontAwesomeIcon
        v-else-if="data"
        v-tooltip="title ? title : capitalize(data.tooltip || '')"
        aria-hidden="true"
        :icon="data.icon"
        :class="data.class"
        fixed-width
    />

</template>